import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { API_BASE_URL } from "../../config";
import { ToastContainer, toast } from "react-toastify";

const TicketFiles = ({ ticketId, getAuthHeader }) => {
  const [files, setFiles] = useState([]);
  const [fileForm, setFileForm] = useState({
    file_name: "",
    file_description: "",
    file: null,
  });
  const [uploading, setUploading] = useState(false);

  /* ---------------- LOAD FILES ---------------- */
  const loadFiles = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/tickets/${ticketId}/files`,
        { headers: getAuthHeader() }
      );
      setFiles(res.data.data || []);
    } catch (err) {
      console.error(err);
      setFiles([]);
    }
  };

  useEffect(() => {
    loadFiles();
  }, [ticketId]);

  /* ---------------- FORM HANDLERS ---------------- */
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFileForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFileForm((prev) => ({ ...prev, file: e.target.files[0] }));
  };

  /* ---------------- SUBMIT ---------------- */
  const submit = async (e) => {
    e.preventDefault();

    if (!fileForm.file) {
      toast.error("Please select a file");
      return;
    }

    try {
      setUploading(true);

      const formData = new FormData();
      formData.append("file_name", fileForm.file_name);
      formData.append("file_description", fileForm.file_description);
      formData.append("attachment_file", fileForm.file);

      await axios.post(
        `${API_BASE_URL}/tickets/${ticketId}/files`,
        formData,
        {
          headers: {
            ...getAuthHeader(),
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success("Attachment uploaded successfully!", {
        position: "bottom-right",
      });

      setFileForm({ file_name: "", file_description: "", file: null });
      loadFiles();
    } catch (err) {
      if (err.response?.status === 422) {
        Object.values(err.response.data.errors).forEach((msg) =>
          toast.error(msg[0])
        );
      } else {
        toast.error("File upload failed");
      }
    } finally {
      setUploading(false);
    }
  };

  /* ---------------- DATATABLE STYLES ---------------- */
  const customStyles = {
    rows: {
      style: {
        minHeight: "34px",
      },
    },
    headCells: {
      style: {
        fontSize: "12px",
        fontWeight: "600",
        padding: "6px",
      },
    },
    cells: {
      style: {
        fontSize: "12px",
        padding: "6px",
      },
    },
  };

  /* ---------------- COLUMNS ---------------- */
  const columns = [
    {
      name: "Action",
      center: true,
      width: "90px",
      cell: (row) =>
        row.download_url ? (
          <a
            href={row.download_url}
            target="_blank"
            rel="noreferrer"
            className="btn btn-sm btn-info"
          >
            View
          </a>
        ) : (
          "-"
        ),
    },
    {
      name: "Title",
      selector: (row) => row.file_title || row.file_name,
      wrap: true,
      sortable: true,          
      grow: 1,
    },
    {
      name: "Description",
      selector: (row) => row.file_description,
      wrap: true,
      sortable: true,          
      grow: 2,
    },
    {
      name: "Date",
      selector: (row) =>
        row.created_at
          ? new Date(row.created_at).toLocaleDateString("en-GB")
          : "-",
      width: "120px",
      sortable: true,          
    },
  ];

  return (
    <div>
      <ToastContainer position="bottom-right" />

      {/* ADD ATTACHMENT */}
      <div className="card p-3 mb-3">
        <h5 className="mb-3">Add Attachment</h5>

        <form onSubmit={submit}>
          <div className="mb-2">
            <label className="form-label">Title</label>
            <input
              className="form-control required-input"
              name="file_name"
              value={fileForm.file_name}
              onChange={handleInputChange}
            />
          </div>

          <div className="mb-2">
            <label className="form-label">Attachment File</label>
            <input
              type="file"
              className="form-control required-input"
              onChange={handleFileChange}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Description</label>
            <textarea
              className="form-control required-input"
              rows={2}
              name="file_description"
              value={fileForm.file_description}
              onChange={handleInputChange}
            />
          </div>

          {/* <button className="btn btn-primary btn-sm" disabled={uploading}>
            {uploading ? "Saving..." : "Save"}
          </button> */}

          <button
  className="btn btn-danger"  
  style={{ backgroundColor: "#dc3545" }}
>
  Save
</button>
        </form>
      </div>

      {/* ATTACHMENT LIST */}
      <div className="card p-2">
        <h5 className="mb-2">Attachment List</h5>

        <DataTable
          columns={columns}
          data={files}
          dense
          striped
          highlightOnHover
          responsive
          pagination
          customStyles={customStyles}
          noDataComponent="No attachments found"
        />
      </div>
    </div>
  );
};

export default TicketFiles;
